export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    WARNING: 'ALERT_WARNING',
    INFO: 'ALERT_INFO',
    CLEAR: 'ALERT_CLEAR'
};
